export default __webpack_public_path__ + "static/media/PPI-pools-026.8ed3dad1.jpg";